import {BaseBlock, theme} from '../../../framework/js/core'

export class ImageSlider extends BaseBlock {
    constructor(root) {
        super(root)
        
        root.find('.image-slider__slider').slick({
            appendArrows: root.find('.image-slider__arrows'),
            prevArrow: root.find('.image-slider__arrow--left'),
            nextArrow: root.find('.image-slider__arrow--right'),
            fade: true,
            speed: 1000,
        })
    }
}